module.exports = __webpack_public_path__ + "img/KJJZHMD_common.ce1a5335.png";